import React, { useState } from 'react';
import { useTranslation } from 'react-i18next';
import { useInfiniteHits } from 'react-instantsearch';

import type { SearchForumCategoryPostsHit } from '../../SearchForumCategoryPosts/types';
import Pagination from '../Pagination';
import Hit from './Hit';

import './style.scss';

const INITIAL_HITS_PER_PAGE = 3;

const SearchForumFollowTopicResults: React.FC = () => {
  const { t } = useTranslation();
  const {
    hits, results, isLastPage, showMore,
  } = useInfiniteHits();
  const [showAll, setShowAll] = useState(false);

  // Determine which hits to display based on showAll state
  const displayedHits = showAll ? hits : hits.slice(0, INITIAL_HITS_PER_PAGE);
  const hasMoreHits = hits.length > INITIAL_HITS_PER_PAGE;

  const handleLoadMore = () => {
    if (!isLastPage) {
      showMore();
    }
    setShowAll(true);
  };

  const handleLoadLess = () => {
    setShowAll(false);
  };

  // Show "Laad meer" when: not showing all OR more data available on server
  const shouldShowLoadMore = !showAll || !isLastPage;

  // Show "Minder laden" when: showing all AND we have more than initial hits
  const shouldShowLoadLess = showAll && hasMoreHits;

  return (
    <>
      <h3 className="SearchForumFollowTopic__title">{t('pages.forum.follow_forum_topic.follow_subjects')}</h3>

      {displayedHits.length === 0 && (
        <p className="SearchForumFollowTopic__text">{t('pages.forum.follow_forum_topic.no_follow_subjects_text')}</p>
      )}

      {displayedHits.length >= 1 && (
        <div className="SearchForumFollowTopic__Results">
          {displayedHits.map((hit: SearchForumCategoryPostsHit) => (
            <Hit key={hit.objectID} hit={hit} />
          ))}
        </div>
      )}

      {results.nbHits > INITIAL_HITS_PER_PAGE && (
        <Pagination
          shouldShowLoadMore={shouldShowLoadMore}
          shouldShowLoadLess={shouldShowLoadLess}
          onLoadMore={handleLoadMore}
          onLoadLess={handleLoadLess}
        />
      )}
    </>
  );
};

export default SearchForumFollowTopicResults;
